define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/core/extendedPathService",
	"csi/reflection",
	"csi/xml"
], function(declare, lang, {parseExtendedPath}, reflection, xml) {

	var ExtendedDataPoint = declare(null, {
		// String
		_id: null,

		// String
		_extendedPath: null,

		constructor: function(/*ExtendedPath*/path, /*String*/attributeOrPropertyId) {
			this._extendedPath = path;
			this._id = attributeOrPropertyId;
		},

		getExtendedPath: function() {
			return this._extendedPath;
		},

		getId: function() {
			return this._id;
		},

		getReflectionAttribute: function() {
			var rc = this.getExtendedPath().getEndClass();
			return reflection.getClassAttribute(rc, this._id);
		},

		getDataType: function() {
			var type = xml.propertyType(this._id);
			if (type) {
				return type;
			}

			var ra = this.getReflectionAttribute();
			return ra ? ra.getType() : null;
		},

		toString: function() {
			return this._extendedPath.toString() + "|" + this._id;
		}
	});

	lang.mixin(ExtendedDataPoint, {
		parse: function(/*String*/strRepresentation) {
			// summary: parse the string representation of the extended data point into a ExtendedDataPoint instance
			if (!strRepresentation)
				return null;

			var arr = strRepresentation.split("|");
			if (arr.length != 2)
				throw new Error("Invalid extended data point=" + strRepresentation);

			return new ExtendedDataPoint(parseExtendedPath(arr[0]), arr[1]);
		}
	});

	return ExtendedDataPoint;
});
